module.exports = __webpack_public_path__ + "static/img/Jason_Johannisen_mobile.b7d9a71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jason_Johannisen_mobile.jpg
// module id = SsbL
// module chunks = 0